import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ConfigService } from '../../shared/utils/config.service';
import { BaseService } from '../../shared/services/base.service';

// Models
import { DepartmentSetupModel } from '../../shared/models/department-setup.model';


@Injectable({
  providedIn: 'root'
})
export class DepartmentSetupService extends BaseService {

  baseApiUrl: string = '';
  postAddUpdateDepartmentApiUrl: string = '';
  getDepartmentByIDApiUrl: string = '';
  getDepartmentApiUrl: string = '';
  getAllDepartmentApiUrl: string = '';
  getServicesByDepartmentApiUrl : string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.postAddUpdateDepartmentApiUrl = this.baseApiUrl + '/Department/AddUpdateDepartment';
    this.getDepartmentByIDApiUrl = this.baseApiUrl + '/Department/GetDepartmentByID';
    this.getDepartmentApiUrl = this.baseApiUrl + '/Department/GetDepartment';
    this.getAllDepartmentApiUrl = this.baseApiUrl + '/Department/GetAllDepartment';
    this.getServicesByDepartmentApiUrl = this.baseApiUrl + '/Department/GetServicesByDepartment'
  }

  postAddUpdateDepartment(body: DepartmentSetupModel) {
    try {
      return this.http.post(this.postAddUpdateDepartmentApiUrl, body).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  // Get data By tblDepartmentId basis Department Details
  getDepartmentByID(tblDepartmentId: number, type: string) {
    try {
      return this.http.get(this.getDepartmentByIDApiUrl + '/' + tblDepartmentId + '/' + type).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }


  //Get All Department Details
  getDepartment(clientId: string, userRole: string, userEmail: string, sqlGlobalFilterString: string = '') {
    try {
      return this.http.get(this.getDepartmentApiUrl + '/' + clientId + '/' + userRole + '/' + userEmail + '/' + sqlGlobalFilterString).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }
  //Get All Department Details
  getAllDepartment(parentDepartmentId: string) {
    try {
      return this.http.get(this.getAllDepartmentApiUrl + '/' + parentDepartmentId).toPromise<any>();

    } catch (Ex) {
      throw Ex;
    }
  }
   //Get Services By Department
  getServicesByDepartment(departmentId: string, departmentId2: string) {
    try {
      return this.http.get(this.getServicesByDepartmentApiUrl + '/' + departmentId + '/' + departmentId2).toPromise<any>();

    } catch (Ex) {
      throw Ex;
    }
  }
}
